<template>
    <div>
        <h3>{{ teamName }}</h3>
        <div v-if="teammate == null">
            <span>邀请好友</span>
            <el-tabs>邀请码: {{ inviteCode }}</el-tabs>
            <img :src="qrsrc">
        </div>
        <div class="teammember" v-else>
            <span>队伍成员</span>
            <span v-if="role == 'leader'">{{ username }}</span>
            <span>
                <span class="teammate">
                    <el-link target="_blank"
                        :href="'https://h5mota.com/user/user.php?uid='+teammate.id"
                    >{{ teammate.name }}</el-link>
                </span>
                <el-button v-if="role == 'leader'" type="danger" size="mini" icon="el-icon-close"
                    @click="handleRemoveTeammate()" :disabled="nodeNow > 1"
                ></el-button>
            </span>
            <span v-if="role == 'member'">{{ username }}</span>
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcode'
import { mapActions, mapGetters, mapState } from 'vuex'

const URL = "https://h5mota.com/competition/another1/index.php?inviteCode=";

export default {
    data() {
        return {
            qrsrc: ""
        }
    },
    created() {
        this.generateQR(this.inviteCode);
    },
    computed: {
        ...mapState([ "username" ]),
        ...mapState("$main", [ "inviteCode", "role", "teammate", "teamName" ]),
        ...mapGetters("$main", [ "nodeNow" ]),
    },
    methods: {
        ...mapActions("$main", [ "removeTeammate" ]),
        async generateQR(code) {
            try {
                this.qrsrc = await QRCode.toDataURL(URL+code);
            } catch (err) {
                console.error(err)
            }
        },
        handleRemoveTeammate() {
            this.$confirm('确定移除队友?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.removeTeammate();
            })
        }
    },
    watch: {
        inviteCode(value) {
            this.generateQR(value);
        }
    }
}
</script>

<style>
.teammember {
    display: flex;
    flex-direction: column;
}
.teammember span {
    padding: 5px;
}
.teammate {
    margin-right: 30px;
}
</style>